import { getRoles } from "@testing-library/react";
import axios from "axios";
import { getName, getToken, getUser } from "../Utils/Common";
import {
    getAPICall,
    getWithParamsAPICall,
    postAPICall,
    putAPICall,
} from "./axiosMethodCalls";
import moment from "moment";

//GET
export const getAllTableStatus = async () => {
    try {
        var payload = {
            requester: getUser(),
            token: getToken(),
        };
        const response = await getWithParamsAPICall(
            process.env.REACT_APP_LINK + "orders/getAllTableStatus", payload
        );
        return { data: response.data };
    } catch (error) {
        return { error: error.response };
    }
};

export const getAllTables = async () => {
    try {
        var payload = {
            requester: getUser(),
            token: getToken(),
        };
        const response = await getWithParamsAPICall(
            process.env.REACT_APP_LINK + "orders/getAllTable", payload
        );
        return { data: response.data };
    } catch (error) {
        return { error: error.response };
    }
};

export const getAllCloseTables = async () => {
    try {
        var payload = {
            requester: getUser(),
            token: getToken(),
        };
        const response = await getWithParamsAPICall(
            process.env.REACT_APP_LINK + "orders/closeTables", payload
        );
        return { data: response.data };
    } catch (error) {
        return { error: error.response };
    }
};

//POST
export const createCount = async (billCount, billsDrawer, coinsInDrawer, coinsRemitted) => {
    
    try {
        let date = new Date().toLocaleDateString("en-CA")
        var date_count = moment(date).format("MM/DD/YYYY")
        var payload = {
            requester:getUser(),
            token:getToken(),
            // ...data,
            bill_1000: billCount[0].qty,
            bill_500: billCount[1].qty,
            bill_200:billCount[2].qty,
            bill_100:billCount[3].qty,
            bill_50:billCount[4].qty,
            bill_20:billCount[5].qty,
            drawer_bill_1000: billsDrawer[0].qty,
            drawer_bill_500: billsDrawer[1].qty,
            drawer_bill_200:billsDrawer[2].qty,
            drawer_bill_100:billsDrawer[3].qty,
            drawer_bill_50:billsDrawer[4].qty,
            drawer_bill_20:billsDrawer[5].qty,
            count_date: date_count, 
            coins_in_drawer: coinsInDrawer,
            coins_remitted: coinsRemitted
        };
        const response = await postAPICall(
            process.env.REACT_APP_LINK + "cash_counts/create",
            payload
        );
        return { data: response.data };
    } catch (error) {
        return { error: error.response };
    }
};

export const transferTable = async (from_table,to_table, orderID) => {
    try {
        var payload = {
            requester:getUser(),
            token:getToken(),
            from_table:from_table,
            to_table:to_table,

        };
    
        const response = await postAPICall(
            process.env.REACT_APP_LINK + "orders/transferTable/"+orderID,
            payload
        );
        return { data: response.data };
    } catch (error) {
        return { error: error.response };
    }
};
